import AppLayout from "components/Layout/AppLayout";
import { useLocation, useNavigate } from "react-router-dom";

import { getBlessing, like, secondsToMidnight, BlessingParams, BlessingType, Blessing} from "services/blessings";
import { useEffect, useState } from "react";
import BlessingCardFull from "components/Blessing/BlessingCardFull";

const BlessingRecievedPage = () => {
    const navigate = useNavigate();
    const { search } = useLocation();
    
    const [blessing, setBlessing] = useState<Blessing | null>(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(search);
        const blessingType = urlParams.get('type') as BlessingType || "";
        const elements = urlParams.get('elements') || "";
        const numbers = urlParams.get('numbers') || "";

        const params: BlessingParams = {
            elements: elements.split(','), 
            numbers: numbers.split(',').map(Number), 
            type: blessingType, 
            secToMidnight: secondsToMidnight()
        };

        getBlessing(params)
        .then((blessing) => {
            if(blessing){
              setBlessing(blessing);
            }
        })
        .catch((error) => {
          console.error(error);
          navigate('/blessings');
        });
    }, []);

    const handleLike = () => {
        if(blessing){
          like(blessing.blessingID, blessing.params.type, !blessing.isLiked);
          setBlessing({...blessing, isLiked: !blessing.isLiked});
        }
    }

    const handleDismiss = () => {
        navigate('/blessings');
    }

    return (
      <AppLayout>
          <BlessingCardFull
            blessing={blessing}
            onDismiss={handleDismiss}
            handleLike={handleLike}
            isLoading={blessing === null}
          />  
        </AppLayout>
    );
    

}

export default BlessingRecievedPage;